import $ from "jquery";

(function(){
    var	deleteWithForm = {
        init: function() {
            $('body').on('click', '.delete-with-form', function(e){
                e.preventDefault();
                var self = $(this);
                if (
                    (   typeof self.data('confirm') != 'undefined' && confirm(self.data('confirm'))) ||
                    typeof self.data('confirm') == 'undefined'
                ) {
                    var deleteForm = $('<form>', {
                        'action': self.attr('href'),
                        'target': '_top',
                        'method': 'POST'
                    }).append($('<input>', {
                        'name': '_method',
                        'value': 'DELETE',
                        'type': 'hidden'
                    })).append($('<input>', {
                        'name': '_token',
                        'value': $('[name="csrf-token"]').attr('content'),
                        'type': 'hidden'
                    }));
                    deleteForm.appendTo('body').submit();
                }
            });
        }
    }.init();
})();


// WEBPACK FOOTER //
// ./resources/assets/js/utils/deleteWithForm.js